import { Component, Input } from '@angular/core';

@Component({
	selector: 'icon-tooltip',
	template: require('./icon-tooltip.component.html')
})
export class IconTooltipComponent {
	@Input() status: 'error' | 'warning' | 'info';
	@Input() text: string;
	@Input() iconClass: string;

	setCorrectIcon(): string {
		if (this.iconClass) {
			return this.iconClass;
		}

		switch (this.status) {
			case 'error':
			case 'warning':
				return 'fi fi-cross';
			case 'info':
				return 'fa fa-exclamation';
			default:
				return 'fi fi-cross';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.ts